import { message } from "antd";
import { Field, Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import apiClient from "../../Actions/apiClient";
import "../Contact/Contact.scss";

export default function ContactSectionForm() {
  const history = useNavigate();
  const onSend = (values) => {
    apiClient.post("contactus/add", values).then(({ data }) => {
      if (data?.result) {
        message.success(
          "Thanks for contacting us! Our team will reach out to you shortly"
        );
        history("/");
      }
    });
  };

  return (
    <div className="contact-form" data-aos="fade-up">
      <Formik
        initialValues={{
          name: "",
          email: "",
          phone: "",
          message: "",
        }}
        onSubmit={onSend}
      >
        <Form>
          <div className="row">
            <div className="field col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <label>Full Name *</label>
              <Field
                name="name"
                // placeholder="Enter your full name.."
                type="text"
                required
              />
            </div>
            <div className="field col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <label>Email Address *</label>

              <Field
                name="email"
                // placeholder="Enter your email address.."
                type="email"
                required
              />
            </div>
            <div className="field col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <label>Phone Number *</label>
              <Field
                name="phone"
                // placeholder="Enter your Phone Number.."
                type="phone"
              />
            </div>
            <div className="field col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <label>Message *</label>

              <Field
                as="textarea"
                // placeholder="Write your message"
                name="message"
                type="text"
                required
              />
            </div>
          </div>
          <button className="ant-btn ant-btn-primary w-100" type="submit">
            Submit
          </button>
        </Form>
      </Formik>
    </div>
  );
}
